// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3ver-","rootSmall":"AddTileButton_rootSmall__vJfIG"};